const stickyElms = document.querySelectorAll('.js-StickyDetector');

function init(element) {
  const styles = getComputedStyle(element);
  const isSticky = styles.getPropertyValue('position') === 'sticky';
  const top = parseInt(styles.getPropertyValue('top'), 10);

  if( !isSticky ) return;

  const observer = new IntersectionObserver( 
    ([e]) => {
      e.target.classList.toggle('is-sticky', e.intersectionRatio < 1);
    },
    { 
      rootMargin: `${top - 1}px 0px 0px 0px`,
      threshold: [1]
    }
  );
  
  observer.observe(element);
}

window.addEventListener('load', () => {
  stickyElms.forEach(element => init(element))
});